var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"communityOwner":_vm.communityOwner,"communityName":_vm.communityName}})}
var staticRenderFns = []

export { render, staticRenderFns }